import { Breadcrumb as AntBreadcrumb, type BreadcrumbProps, type BreadcrumbRef } from 'antd'
import { forwardRef } from 'react'

export type UiBreadcrumbProps = BreadcrumbProps

const UiBreadcrumbComponent = forwardRef<BreadcrumbRef, UiBreadcrumbProps>((props, ref) => (
  <AntBreadcrumb ref={ref} {...props} />
))

UiBreadcrumbComponent.displayName = 'UiBreadcrumb'

export const UiBreadcrumb = Object.assign(UiBreadcrumbComponent, {
  Item: AntBreadcrumb.Item,
  Separator: AntBreadcrumb.Separator,
})

export default UiBreadcrumb
